export interface IParam{
  shouldRefetch: boolean;
  resetRefetch: () => void;
  linkAction: (url:string) => void;
  generateAction: (data: any, action: string) => void;
  dialogData?: IReprintOrCreditNote | null;
}

export interface IReprintOrCreditNote {
  isCreateCreditNote: boolean,
  isReprint: boolean,
  selectedItem: any,
  selectedCountry: string
}
export const defaultReprintOrCreditNote = {
  isCreateCreditNote: false,
  isReprint: false,
  selectedItem: [],
  selectedCountry: ''
}
export const checkStateValid = (status:string, type:string, action?:string):boolean => {
    const check:boolean = Boolean(action && action !== 'creditNode')? !Boolean(action):
        !((Boolean(status) && status.toLowerCase() ==='final invoice created') && type.toLowerCase() === 'final')
    return check
}
export const checkCanceled = (status:string):boolean => {
    const check:boolean = Boolean(status && status.toLowerCase() ==='invoice cancelled')
    return check
}
export const isFinal = (type:string):boolean => {
    const check:boolean = Boolean(type && type.toLowerCase() ==='final')
    return check
}
export const isCredit = (type:string):boolean => {
    const check:boolean = Boolean(type && type.toLowerCase() ==='credit')
    return check
}
export const displayExtraFields = (status:string):boolean => {
    const check:boolean = Boolean(status && (status.toLowerCase().includes('credit note') || status.toLowerCase() === 'final invoice created'))
    return check
}
export const invoiceTypeDialog = [
    {optionText: 'Credit', value: 'credit'},
    {optionText: 'Draft', value: 'draft'},
    {optionText: 'Final', value: 'final'},
    {optionText: 'New', value: 'new'}
]